export { default as STATS_QUERY } from './Stats.graphql';
export { default as STATS_HEATMAP_QUERY } from './StatsHeatmap.graphql';
export { default as STATS_CHART_QUERY } from './StatsChart.graphql';
export { default as STATS_CHANNEL_QUERY } from './StatsChannel.graphql';
export { default as STATS_LOCATION_QUERY } from './StatsLocation.graphql';
export { default as STATS_DEVICE_QUERY } from './StatsDevices.graphql';
